export enum ErrorConstants {
	QRCODE_NOT_ACTIVE = 'QRCODE_NOT_ACTIVE',
	PERMISSION_DENIED = 'PERMISSION_DENIED',
	EQUIPMENT_NOT_ACTIVE = 'EQUIPMENT_NOT_ACTIVE',
	QRCODE_ALREADY_USED = 'QRCODE_ALREADY_USED',
	SPACE_NOT_ACTIVE = 'SPACE_NOT_ACTIVE',
	QRCODE_NOT_FOUND = 'QRCODE_NOT_FOUND'
}